import { Injectable } from '@angular/core';
import { CurrencyService } from '@rd/core/services/currency/currency.service';
import { GiftCardOrderItem, Order, OrderItem, OrderItemType } from '@rd/types';

@Injectable({
  providedIn: 'root',
})
export class OrderHelper {
  constructor(private currencyService: CurrencyService) {}

  giftCardOrderItemAmountAndName(order: Order): string {
    const orderItem = order.orderItems.find(
      orderItemFilter<GiftCardOrderItem>(OrderItemType.GiftCardOrderItem),
    );
    if (!orderItem) {
      return '';
    }
    const { amount, productName } = orderItem.attributes.data;
    return `${productName} ${this.currencyService.formatCurrency(
      amount,
      'symbol',
    )}`;
  }

  // We truncate this just so the customer has a reference ID when contacting us, but they don't
  // have the entire ID which is long
  public displayedId(order: Order): string {
    return order.id.substring(0, 8).toUpperCase();
  }
}

export const orderItemFilter =
  <T extends OrderItem>(...types: OrderItemType[]) =>
  (orderItem: OrderItem): orderItem is T =>
    types.includes(orderItem.type);
